import { render, staticRenderFns } from "./LearningGoalInfo.vue?vue&type=template&id=10da4511&scoped=true&"
import script from "./LearningGoalInfo.vue?vue&type=script&lang=js&"
export * from "./LearningGoalInfo.vue?vue&type=script&lang=js&"
import style0 from "./LearningGoalInfo.vue?vue&type=style&index=0&id=10da4511&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da4511",
  null
  
)

export default component.exports